import { Container, Button,Form, Alert,Table} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,StyckeCompact} from "./ContentStyles";
import React, { useState ,useEffect} from 'react';
import useBackend, {CallAPI, Loading, SpinnerX} from '../services/useBackend';
import {useParams, useNavigate} from 'react-router-dom';
import { FaFilePdf, FaReceipt, FaEnvelope, FaUser } from 'react-icons/fa';
import ReactPlayer from 'react-player';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions} from '../services/misc';

import {Branding} from '../services/misc';

var typingTimeout = null;
var orderGUID = null;

function handleChange(event){
	clearTimeout(typingTimeout);
	typingTimeout = setTimeout(handleSave, 475);
}

function handleSave(){
	const ProductForm = document.getElementById('ProductForm');
	const formData = new FormData(ProductForm);

	const formDataObj = Object.fromEntries(formData.entries());

	formDataObj.Swish       = formData.has('Swish') ? true : false;
    formDataObj.Card        = formData.has('Card') ? true : false;
	formDataObj.TestPayment = formData.has('TestPayment') ? true : false;

	// PatchBackend('/api/admin/shop/'+shopGUID,JSON.stringify(formDataObj));
}

function openPriceList(event){
	// window.open('https://www.nookshop.se/api/info/'+shopGUID+'/Pricelist', '_blank', 'noreferrer');
}

export default function OrderDetails() {
    const {OrderGUID} = useParams();
    orderGUID = OrderGUID;    
	const {resultVariant, resultVisible, resultText, loading, data, Refresh} =  useBackend('/api/admin/orders/'+OrderGUID);

	const navigate = useNavigate();

	const customerClick = (event)  =>  {
        const customerguid = event.currentTarget.getAttribute("customerguid");
        navigate("/customer/"+customerguid);
    }  

	const setOrderStateClick = (event)  =>  {
        const NewState = event.currentTarget.getAttribute("NewState");
		CallAPI('/api/admin/Orders/'+orderGUID,"PATCH","{\"NewOrderState\":\"10\"}");
		Refresh();
    }

	const SwishRefoundClick = async (event)  =>  {
		await CallAPI('/api/admin/Orders/'+orderGUID+"/SwishRefound","PATCH","");
        // Refresh(pagination.pageIndex, pagination.pageSize);
    }    

	const handleCheckPaymentState = (event) => {
		console.log(orderGUID);
		CallAPI('/api/admin/Orders/'+orderGUID+"/CheckPaymentState","PATCH","");
		Refresh();
	}


	const statesAllowedForCancellation = [1, 2, 9];

    if (!loading) {
        return (
            <ContentWrapper>
                <Container>
                    <Sida>
						<Rubrik>Försäljning (Order: {data.SerialNumber})</Rubrik>		
						<StyckeCompact>
							<>Skapad:        {DateTimeToLocal(data.Created)}</>

							{data.OrderState==8 && data.PaymentMethod==2 &&
								<>
									<Button className="QmeButton"  style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="button" onClick={handleCheckPaymentState}>Uppdatera Swishstatus</Button>    
								</>
							}

							
							{statesAllowedForCancellation.includes(data.OrderState) &&
								<>
									&nbsp;<Button className="QmeButton"  style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="button"  onClick={setOrderStateClick} newstate="10">Makulera</Button>    
								</>
							}

							{data.OrderState==999 &&
								<>
									<Button className="QmeButton"  style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="button" onClick={SwishRefoundClick}>Återbetala Swish</Button>    
								</>
							}							
							
						</StyckeCompact>						

						<Rubrik>Kund <span style={{padding:5}} className='sub_' customerguid={data.Buyer.Guid} onClick={customerClick} title="Info "><FaUser /></span></Rubrik>
						<StyckeCompact>
							<>Name:    {data.Buyer.Name}</><br />
							<>SSN:     {data.Buyer.SSN}</><br />
							<>eMail:   {data.Buyer.eMail}</><br />
						</StyckeCompact>

						<Rubrik>Betalning</Rubrik>
						<StyckeCompact>
						<>Betalmetod:   {data.PaymentMethodText}</><br /> 
							<>Betalreferens:   {data.PaymentReference}</><br /> 
							<>Status:       {data.OrderStateText}</>
						</StyckeCompact>						

						<Rubrik>Butik</Rubrik>
						<StyckeCompact>
							<>Name:        {data.Shop.Name}</><br />
							<>Description: {data.Shop.Description}</>

						</StyckeCompact>						

						<Rubrik>Varor/Köp</Rubrik>

							<Table  responsive="sm">
								<thead>
									<tr><th>Namn</th><th>Antal</th><th>Pris</th><th>Moms</th></tr>
								</thead>
								<tbody>
									{data.BasketItemList.map((item) => {
										return <tr key={item.Name}><td>{item.Name}</td><td>{item.Qty}</td><td>{item.Price}</td><td>{item.Vat}%</td></tr>
									})}

									<tr><td></td><th>Totalt</th><td>{data.BasketTotalAmount}</td><td>{data.BasketTotalVat}</td></tr>
								</tbody>
							</Table>
                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);        
    }
}